import { Icon } from '@chakra-ui/react';
import { FaHome, FaList } from 'react-icons/fa';
import { BsPeopleFill } from 'react-icons/bs';
import { Outlet } from 'react-router-dom';
import Homepage from './Pages/Homepage/Homepage';
import FormListPage, { FormListLoader } from './Pages/Forms/Forms';
import FormSubmissionsPage, { FormSubmissionsLoader } from './Pages/FormSubmissions/FormSubmissions';
import EditFormPage from './Pages/EditForm/EditForm';
import HelpPage from './Pages/Help';
import Navigate from './Core/Navigate';
import PreviewForm from './Pages/PreviewForm/PreviewForm';
import TemplatesListPage, { TempalteListLoader } from './Pages/Templates/Templates';
import EditTemplatePage from './Pages/EditTemplate/EditTemplate';
import FormLayout from './Pages/Forms/FormLayout';
import TemplateLayout from './Pages/Templates/TemplateLayout';
import OrgMembersPage from './Pages/Organization/Members';
import AcceptInvitePage from './Pages/Invite/AcceptInvite';

const routes = [
  { index: true, element: <Navigate to="/dashboard" replace />, hidden: true },
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <Icon as={FaHome} />,
    element: <Homepage />,
    layout: '/admin',
    loader: () => ({ name: 'Dashboard' }),
  },
  {
    path: '/forms',
    name: 'Forms',
    icon: <Icon as={FaList} />,
    element: <FormListPage />,
    layout: '/admin',
    loader: FormListLoader(),
  },
  {
    path: '/form',
    name: 'Form1',
    element: <Outlet />,
    hidden: true,
    loader: () => ({ name: 'Form', to: '/forms' }),
    children: [{
      path: '/form/:formId',
      name: 'Form2',
      element: <FormLayout />,
      layout: '/admin',
      id: 'formId',
      loader: () => ({ hidden: true }),
      children: [{
        path: '',
        element: <Navigate to="submissions" />,
      }, {
        path: 'submissions',
        name: 'Submissions',
        element: <FormSubmissionsPage />,
        loader: FormSubmissionsLoader(),
      }, {
        path: 'edit',
        name: 'Edit',
        element: <EditFormPage />,
        loader: () => ({ layout: 'full' }),
      }, {
        path: 'edit/preview',
        name: 'Preview',
        element: <PreviewForm />,
        loader: () => ({ layout: 'full' }),
      }],
    }],
  },
  {
    path: '/templates',
    name: 'Templates',
    icon: <Icon as={FaList} />,
    element: <Outlet />,
    layout: '/admin',
    loader: TempalteListLoader(),
    children: [{
      path: '',
      element: <TemplatesListPage />,
    }, {
      path: '/templates/:templateId',
      name: 'Tempalte',
      element: <TemplateLayout />,
      layout: '/admin',
      id: 'tempalteId',
      loader: () => ({ hidden: true }),
      children: [{
        path: '',
        element: <Navigate to="edit" />,
      }, {
        path: 'edit',
        name: 'Edit',
        element: <EditTemplatePage />,
        loader: () => ({ layout: 'full' }),
      }, {
        path: 'edit/preview',
        name: 'Preview',
        element: <PreviewForm />,
        loader: () => ({ layout: 'full' }),
      }],
    }],
  },
  {
    path: '/help',
    name: 'Help',
    hidden: true,
    loader: () => ({ name: 'Help' }),
    element: <HelpPage />,
  },
  {
    path: '/organization',
    name: 'Organization',
    icon: <Icon as={BsPeopleFill} />,
    element: <OrgMembersPage />,
    layout: '/admin',
    loader: () => ({ name: 'Organization', auth: ['admin', 'owner'] }),
  },
  {
    path: '/invite/accept',
    name: 'AcceptInvite',
    hidden: true,
    element: <AcceptInvitePage />,
    loader: () => ({ layout: 'full', hidden: true }),
  },
];
export default routes;
